import { PoolObject } from '@core';
import { isValidIMEI } from 'app/shared/helper-functions';

export function isObjectDetailsComplete(device: PoolObject): boolean {
    if (!device.ObjectDetail || device.ObjectDetail.length < 3) {
        return false;
    }
    if (device.ObjectType === 'Smartphone') {
        return isValidIMEI(device.ObjectDetail);
    }
    return true;
}
